const HorizontalSpace = ({ size }) => {
  const sizeClass =
    size === 'lg' ? 'h-20 xl:h-40' : size === 'sm' ? 'h-5 xl:h-10' : size === 'xs' ? 'h-2.5 xl:h-5' : 'h-10 xl:h-20';

  return <div className={`${sizeClass} w-full`} />;
};

export default HorizontalSpace;
